export default __webpack_public_path__ + "ea2986e6436fa0e8a8f6780c643fd86e.png";